import { t } from '@lingui/core/macro';
import { Box, EmptyState } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { SelectWorkflow } from './SelectWorkflow';
export function WorkflowInitialState(props) {
    const { workflows, onSelectWorkflow } = props;
    return (<Box flexDirection="column" p="xl" height="100%">
      <EmptyState withAvatar icon={<Falcon icon="eye"/>} title={t({
            comment: 'Document approval check - Approval might be needed title',
            message: 'Approval might be needed',
        })} description={t({
            comment: 'Document approval check - Approval might be needed description',
            message: 'This document might need internal approval before sending for eSigning',
        })} actions={<SelectWorkflow matchedWorkflows={workflows} onSelect={onSelectWorkflow}/>}/>
    </Box>);
}
